import { render, staticRenderFns } from "./SocialRespCenterTable.vue?vue&type=template&id=0ead524d&scoped=true&"
import script from "./SocialRespCenterTable.vue?vue&type=script&lang=js&"
export * from "./SocialRespCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./SocialRespCenterTable.vue?vue&type=style&index=0&id=0ead524d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead524d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VIcon,VSimpleTable})
